import type { ReactNode } from 'react';
import { theme } from '../../../theme';

type MetricCardProps = {
  label: string;
  value: string | number;
  icon: ReactNode;
  accent?: string;
  subtitle?: string;
};

export const MetricCard = ({ label, value, icon, accent, subtitle }: MetricCardProps) => (
  <div className={`${theme.card.padded} flex items-start gap-4`}>
    <div className={accent ?? theme.icon.tealSm}>{icon}</div>
    <div className="min-w-0 flex-1">
      <p className={`text-xs font-medium uppercase tracking-wider ${theme.text.muted} mb-1`}>{label}</p>
      <p className={`text-2xl font-bold ${theme.text.heading} leading-none`}>{value}</p>
      {subtitle && <p className={`text-xs ${theme.text.muted} mt-1`}>{subtitle}</p>}
    </div>
  </div>
);
